import ChartSingleVehiclePie from './ChartSingleVehiclePie';

export default ChartSingleVehiclePie;
